export const site = {
  is: {
    title: "Vefsíða",
    homeTitle: "Vefsíðugerð og stafrænar lausnir",
    description: "Við hjálpum fyrirtækjum að ná árangri á netinu með sérsniðnum veflausnum, faglegri hönnun og framúrskarandi þjónustu.",
    keywords: "vefsíðugerð, vefhönnun, vefþróun, veflausnir, wordpress, netverslun, leitarvélabestun, vefumsjón"
  },
  en: {
    title: "Vefsíða",
    homeTitle: "Web Development and Digital Solutions",
    description: "We help businesses succeed online with custom web solutions, professional design, and exceptional service.",
    keywords: "web development, web design, web programming, web solutions, wordpress, ecommerce"
  },
  es: {
    title: "Vefsíða",
    homeTitle: "Desarrollo Web y Soluciones Digitales",
    description: "Ayudamos a las empresas a tener éxito en línea con soluciones web personalizadas, diseño profesional y servicio excepcional.",
    keywords: "desarrollo web, diseño web, programación web, soluciones web, wordpress, comercio electrónico"
  },
  da: {
    title: "Vefsíða",
    homeTitle: "Webdesign og Digitale Løsninger",
    description: "Vi hjælper virksomheder med at få succes online med skræddersyede webløsninger, professionelt design og enestående service.",
    keywords: "webudvikling, webdesign, webprogrammering, webløsninger, wordpress, e-handel"
  }
};